"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const SearchInput = ({ placeholder, onTextChange, autoFocus, size = 'normal', value }) => {
    const handleChange = (e) => {
        if (onTextChange)
            onTextChange(e.currentTarget.value);
    };
    return (0, jsx_runtime_1.jsx)("input", { className: `form-control bg-white ${size === 'large' ? 'form-control-lg' : ''}`, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Hledejte ...", onChange: handleChange, autoFocus: autoFocus, value: value });
};
exports.SearchInput = SearchInput;
